<template>
  <div>
    <!-- Botões de Ação (Adicionar Equipamento e Filtrar) -->
    <div class="flex flex-col md:flex-row md:items-center md:justify-between mb-6 space-y-3 md:space-y-0 md:space-x-3">
      <!-- Grupo de Ações Principais -->
      <div class="flex flex-col md:flex-row md:items-center w-full space-y-2 md:space-y-0 md:space-x-3">
        <!-- Botão Adicionar Equipamento -->
        <button @click="$emit('open-modal', 'equipment')"
          class="w-full md:w-auto bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-all duration-200 transform hover:scale-105 flex items-center justify-center gap-2 font-medium shadow-lg">
          <PlusCircle class="w-5 h-5" />
          <span>Adicionar Equipamento</span>
        </button>

        <!-- Botão Gerar Relatório -->
        <button @click="$emit('open-modal', 'relatorio')"
          class="w-full md:w-auto bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-all duration-200 transform hover:scale-105 flex items-center justify-center gap-2 font-medium shadow-lg">
          <Send class="w-5 h-5" />
          <span>Gerar Relatório</span>
        </button>

        <!-- Botão Gerar Token -->
        <button @click="$emit('go-to-gerar-token')"
          class="w-full md:w-auto bg-green-600 text-white px-6 py-3 rounded-lg hover:bg-green-700 transition-all duration-200 transform hover:scale-105 flex items-center justify-center gap-2 font-medium shadow-lg">
          <KeyIcon class="w-5 h-5" />
          <span>Gerar Token</span>
        </button>

      </div>

      <!-- Busca Simples -->
      <div class="w-full md:w-auto">
        <input 
          v-model="searchQuery" 
          type="text" 
          placeholder="Buscar equipamentos..."
          class="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
        />
      </div>
    </div>

    <!-- Tabela de Equipamentos (Desktop) -->
    <div class="hidden md:block overflow-x-auto bg-white dark:bg-gray-800 rounded-lg shadow">
      <table class="min-w-full table-fixed divide-y divide-gray-200 dark:divide-gray-700">
        <thead class="bg-blue-500 dark:bg-blue-600 text-white dark:text-gray-300 text-xs uppercase tracking-wide">
          <tr>
            <th @click="handleSort('serial_number')" class="py-4 px-6 w-1/5 text-left cursor-pointer">
              Serial Number
              <span v-if="store.sortColumn === 'serial_number'">
                {{ store.sortDirection === 'asc' ? '⭡' : '⭣' }}
              </span>
            </th>
            <th @click="handleSort('modelo_nome')" class="py-4 px-6 w-1/5 text-left cursor-pointer">
              Nome
              <span v-if="store.sortColumn === 'modelo__nome'">
                {{ store.sortDirection === 'asc' ? '⭡' : '⭣' }}
              </span>
            </th>
            <th @click="handleSort('tipo')" class="py-4 px-6 w-1/5 text-left cursor-pointer">
              Tipo
              <span v-if="store.sortColumn === 'tipo__nome'">
                {{ store.sortDirection === 'asc' ? '⭡' : '⭣' }}
              </span>
            </th>
            <th class="py-4 px-6 w-1/5 text-left">
              Unidade
            </th>
            <th class="py-4 px-6 w-1/5 text-left">
              Kit
            </th>
            <th class="py-4 px-6 w-1/5 text-left">
              Responsável
            </th>
            <th @click="handleSort('status')" class="py-4 px-6 w-1/5 text-left cursor-pointer">
              Status
              <span v-if="store.sortColumn === 'status'">
                {{ store.sortDirection === 'asc' ? '⭡' : '⭣' }}
              </span>
            </th>
            <th class="py-4 px-6 w-1/5 text-left">Ações</th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200 dark:bg-gray-800 dark:divide-gray-700">

          <tr v-for="equipment in equipamentosExibidos" :key="equipment.id" class="hover:bg-gray-50 dark:hover:bg-gray-700">
            <td class="py-4 px-6 text-sm font-medium text-gray-900 dark:text-white">
              {{ equipment.serial_number }}
            </td>
            <td class="py-4 px-6 text-sm font-medium text-gray-900 dark:text-white">
              {{ equipment.modelo_nome }}
            </td>
            <td class="py-4 px-6 text-sm font-medium text-gray-900 dark:text-white">
              {{ equipment.tipo }}
            </td>
            <td class="py-4 px-6 text-sm font-medium text-gray-900 dark:text-white">
              {{ equipment.kits.length > 0 ? equipment.kits[0].unidade : 'N/A' }}
            </td>
            <td class="py-4 px-6 text-sm font-medium text-gray-900 dark:text-white">
              {{ equipment.kits.length > 0 ? equipment.kits[0].kit_code : 'N/A' }}
            </td>
            <td class="py-4 px-6 text-sm font-medium text-gray-900 dark:text-white">
              {{
                equipment.kits.length > 0
                  ? equipment.kits[0].responsavel_interno?.nome
              : 'N/A'
              }}
            </td>

            <td class="py-4 px-6 text-sm text-gray-500 dark:text-gray-400">
              <div class="flex items-center justify-center">
                <span :class="getStatusClass(equipment.status)">
                  {{ equipment.status }}
                </span>
                <span v-if="equipment.alerta" class="alerta-icon ml-2 inline-flex items-center">
                  <TriangleAlert class="w-5 h-5 text-yellow-600" />
                  <div class="tooltip">
                    {{ equipment.alerta }}
                  </div>
                </span>
              </div>
            </td>


            <td class="py-4 px-6 text-sm font-medium">
              <!-- Botão de Editar -->
              <button @click="$emit('edit-equipment', equipment)"
                class="text-blue-600 hover:text-blue-900 dark:text-blue-500 dark:hover:text-blue-400 mr-3">
                <Edit2 class="w-5 h-5" />
              </button>
              <button @click="$emit('ver-detalhes', equipment.id)"
                class="text-blue-600 hover:text-blue-900 dark:text-blue-500 dark:hover:text-blue-400 mr-3">
                <EyeIcon v-if="equipment.validado" class="w-5 h-5" />
              </button>
              <!-- Botão de Excluir -->
              <button @click="$emit('delete-equipment', equipment)"
                class="text-red-600 hover:text-red-900 dark:text-red-500 dark:hover:text-red-400">
                <Trash2 class="w-5 h-5" />
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>





    <!-- Cards de Equipamentos (Mobile) -->
    <div class="block md:hidden space-y-4">
      <div v-for="equipment in equipamentosExibidos" :key="equipment.id"
        class="bg-white dark:bg-gray-800 rounded-lg shadow p-4">
        <!-- Serial Number -->
        <div class="flex items-center space-x-2">
          <span class="text-sm font-semibold text-gray-700 dark:text-gray-300">Serial Number:</span>
          <span class="text-sm text-gray-500 dark:text-gray-400">{{ equipment.serial_number }}</span>
        </div>

        <!-- Modelo -->
        <div class="flex items-center space-x-2">
          <span class="text-sm font-semibold text-gray-700 dark:text-gray-300">Modelo:</span>
          <span class="text-sm text-gray-500 dark:text-gray-400">{{ equipment.modelo_nome }}</span>
        </div>

        <!-- Tipo -->
        <div class="flex items-center space-x-2">
          <span class="text-sm font-semibold text-gray-700 dark:text-gray-300">Tipo:</span>
          <span class="text-sm text-gray-500 dark:text-gray-400">{{ equipment.tipo }}</span>
        </div>

        <!-- Unidade -->
        <div class="flex items-center space-x-2">
          <span class="text-sm font-semibold text-gray-700 dark:text-gray-300">Unidade:</span>
          <span class="text-sm text-gray-500 dark:text-gray-400">{{ equipment.kits.length > 0 ?
            equipment.kits[0].unidade :
            'N/A' }}</span>
        </div>

        <!-- Status -->
        <div class="flex items-center space-x-2">
          <span class="text-sm font-semibold text-gray-700 dark:text-gray-300">Status:</span>
          <span class="text-sm" :class="getStatusClass(equipment.status)">{{ equipment.status }}</span>
        </div>

        <!-- Token -->
        <div class="flex items-center space-x-2">
          <span class="text-sm font-semibold text-gray-700 dark:text-gray-300">Token:</span>
          <span class="text-sm text-gray-500 dark:text-gray-400">{{ equipment.token || 'N/A' }}</span>
        </div>

        <!-- Botões de Ação -->
        <div class="flex justify-end space-x-2 mt-2">
          <!-- Botão de Visualizar Detalhes -->
          <button @click="$emit('ver-detalhes', equipment.id)"
            class="text-blue-600 hover:text-blue-900 dark:text-blue-500 dark:hover:text-blue-400">
            <EyeIcon class="w-5 h-5" />
          </button>

          <!-- Botão de Editar -->
          <button @click="$emit('edit-equipment', equipment)"
            class="text-blue-600 hover:text-blue-900 dark:text-blue-500 dark:hover:text-blue-400">
            <Edit2 class="w-5 h-5" />
          </button>

          <!-- Botão de Excluir -->
          <button @click="$emit('delete-equipment', equipment)"
            class="text-red-600 hover:text-red-900 dark:text-red-500 dark:hover:text-red-400">
            <Trash2 class="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
    <!-- Paginação estilizada igual à AbaKits -->
    <div class="flex flex-col md:flex-row md:items-center md:justify-between my-4 gap-2">
      <div class="flex items-center gap-2 justify-center">
        <button :disabled="currentPage === 1" @click="store.setCurrentPage(currentPage - 1); carregarEquipamentos()"
          class="px-3 py-1 rounded bg-blue-500 dark:bg-gray-700 text-gray-200 dark:text-gray-200 disabled:opacity-50">Anterior</button>
        <span class="text-sm text-gray-700 dark:text-gray-200">Página {{ currentPage }} de {{ totalPages }}</span>
        <button :disabled="currentPage === totalPages"
          @click="store.setCurrentPage(currentPage + 1); carregarEquipamentos()"
          class="px-3 py-1 rounded bg-blue-500 dark:bg-gray-700 text-gray-200 dark:text-gray-200 disabled:opacity-50">Próxima</button>
      </div>
      <div class="flex items-center gap-2 justify-center">
        <label for="page-size" class="text-sm text-gray-700 dark:text-gray-200">Itens por página:</label>
        <select id="page-size" :value="pageSize"
          @change="store.setPageSize(Number($event.target.value)); store.setCurrentPage(1); carregarEquipamentos()"
          class="rounded border px-2 py-1 text-sm dark:bg-gray-700 dark:text-white">
          <option :value="5">5</option>
          <option :value="10">10</option>
          <option :value="20">20</option>
          <option :value="50">50</option>
        </select>
        <span v-if="store.totalCount !== undefined && store.totalCount !== null"
          class="text-xs text-gray-500 dark:text-gray-400">Total: {{ store.totalCount }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>

import { onMounted, computed, onUnmounted } from 'vue';
import { Edit2, Trash2, KeyIcon, PlusCircle, Send, EyeIcon } from 'lucide-vue-next';
import { useEquipamentosStore } from '@/stores/assets/EquipamentosStore';
import { storeToRefs } from 'pinia';

// Removed unused ref variables

const store = useEquipamentosStore();
// Recebendo as props de listas completas para filtros
// eslint-disable-next-line no-undef
defineProps({
  tipos: {
    type: Array,
    default: () => []
  },
  models: {
    type: Array,
    default: () => []
  },
  unidades: {
    type: Array,
    default: () => []
  }
});

// Usando storeToRefs para manter a reatividade das propriedades da store
const { filters } = storeToRefs(store);

// Removed unused emit

// Estado de paginação agora controlado pelo Pinia
const { currentPage, pageSize, totalPages } = storeToRefs(store);
// Equipment list comes from store Pinia and is accessed via filteredEquipamentos

const carregarEquipamentos = async () => {
  try {
    const params = new URLSearchParams();
    // Paginação
    params.append('page', currentPage.value);
    params.append('page_size', pageSize.value);

    // Filtros vindos do store
    if (filters.value.unidade) params.append('unidade', Number(filters.value.unidade));
    if (filters.value.status) params.append('status', filters.value.status);
    if (filters.value.tipo) params.append('tipo', filters.value.tipo);
    if (filters.value.modelo) params.append('modelo', filters.value.modelo);
    if (filters.value.disponiveis) params.append('disponiveis', filters.value.disponiveis);
    if (filters.value.com_token) params.append('com_token', filters.value.com_token);
    if (filters.value.serial_number) params.append('serial_number', filters.value.serial_number);
    if (filters.value.token) params.append('token', filters.value.token);
    if (filters.value.responsavel_interno) params.append('responsible', filters.value.responsavel_interno);
    if (filters.value.search) params.append('search', filters.value.search);

    // Ordenação
    if (store.sortColumn) params.append('sortColumn', store.sortColumn);
    if (store.sortDirection) params.append('sortDirection', store.sortDirection);

    console.log('[carregarEquipamentos] Fetching:', `/api/v1/actives/?${params.toString()}`);
    const response = await fetch(`/api/v1/actives/?${params.toString()}`, {
      credentials: "include"
    });
    console.log('[carregarEquipamentos] Response:', response);

    if (!response.ok) throw new Error("Erro ao carregar equipamentos");

    const data = await response.json();
    console.log('[carregarEquipamentos] Data:', data);
    store.setEquipamentos(data.items);
    store.setTotalPages(data.pages);
    store.setTotalCount(data.count);

    console.log('[AbaEquipamentos] equipamentos atualizado:', store.equipamentos);
  } catch (error) {
    alert('Erro ao buscar equipamentos: ' + error);
    console.error("Erro ao buscar equipamentos:", error);
  }
};

// Busca simples integrada ao backend
const equipamentosExibidos = computed(() => store.equipamentos);

let searchTimer = null;
const searchQuery = computed({
  get() {
    return filters.value.search || '';
  },
  set(value) {
    filters.value.search = value;
    store.setCurrentPage(1);
    if (searchTimer) clearTimeout(searchTimer);
    searchTimer = setTimeout(() => {
      carregarEquipamentos();
    }, 300);
  }
});

// Removed unused fetchSetores function

// Removed unused fetchUnidades function

// Removed unused fetchModels function

// Removed unused fetchMarcas function

// Removed unused fetchTipos function

// Removed unused fetchResponsibles function



// Manipular ordenação
const handleSort = (column) => {
  // Corrige nomes para o backend
  let backendColumn = column;
  if (column === 'modelo_nome') backendColumn = 'modelo__nome';
  if (column === 'tipo') backendColumn = 'tipo__nome';
  // Só permite campos aceitos pelo backend
  const allowed = ['id', 'serial_number', 'modelo__nome', 'tipo__nome', 'status', 'token'];
  if (!allowed.includes(backendColumn)) backendColumn = 'id';
  store.toggleSort(backendColumn);
  carregarEquipamentos();
};

// Agora os tipos, modelos e unidades vêm das props recebidas do componente pai.
// Não é mais necessário computar a partir dos equipamentos exibidos.


const getStatusClass = (status) => {
  switch (status) {
    case 'Disponível':
      return 'text-green-600 dark:text-green-400';
    case 'Em uso':
      return 'text-blue-600 dark:text-blue-400';
    case 'Em manutenção':
      return 'text-yellow-600 dark:text-yellow-400';
    default:
      return 'text-gray-600 dark:text-gray-400';
  }
};

function handleKitAdicionado(event) {
  console.log('[AbaEquipamentos] Evento kit-adicionado recebido', event);
  carregarEquipamentos();
}




onMounted(() => {
  carregarEquipamentos();
  if (typeof window !== 'undefined') {
    window.addEventListener('kit-adicionado', handleKitAdicionado);
  }
});
onUnmounted(() => {
  if (typeof window !== 'undefined') {
    window.removeEventListener('kit-adicionado', handleKitAdicionado);
  }
});



// Permite que o componente pai acesse carregarEquipamentos via ref
import { defineExpose } from 'vue';
defineExpose({ carregarEquipamentos });



</script>
